import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StyledSelectWoController } from "../../styled/StyledSelectWoController";
import { NavElement } from "./navElementProps";

export const GeneralInfoNav = () => {
  const { t } = useTranslation("boClients");
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<number>(Number(searchParams.get("subTab")) || 0);

  const handleUpdateTab = useCallback(
    (index: number) => {
      setActiveTab(index);

      setSearchParams({
        tab: searchParams.get("tab") || "0",
        subTab: index.toString(),
      });
    },
    [setActiveTab, setSearchParams, searchParams],
  );

  useEffect(() => {
    handleUpdateTab(activeTab);
  }, [handleUpdateTab, activeTab]);

  return (
    <>
      <div className="hidden w-fit flex-row self-start rounded-lg border border-gray-300 bg-white p-0.5 md:flex">
        <NavElement
          title={t("profileGeneralInfoNav.tabs.company")}
          index={0}
          active={activeTab === 0}
          handleActiveTab={handleUpdateTab}
        />
        <NavElement
          title={t("profileGeneralInfoNav.tabs.users")}
          index={1}
          active={activeTab === 1}
          handleActiveTab={handleUpdateTab}
        />
        <NavElement
          title={t("profileGeneralInfoNav.tabs.pickup")}
          index={2}
          active={activeTab === 2}
          handleActiveTab={handleUpdateTab}
        />
        <NavElement
          title={t("profileGeneralInfoNav.tabs.payment")}
          index={3}
          active={activeTab === 3}
          handleActiveTab={handleUpdateTab}
        />
      </div>
      <div className="flex w-full items-center justify-center md:hidden">
        <StyledSelectWoController
          placeholder={t("profileGeneralInfoNav.selectPlaceholder")}
          isClearable={false}
          isSearchable={false}
          options={[
            { label: t("profileGeneralInfoNav.tabs.company"), value: "0" },
            { label: t("profileGeneralInfoNav.userOption"), value: "1" },
            { label: t("profileGeneralInfoNav.tabs.pickup"), value: "2" },
            { label: t("profileGeneralInfoNav.tabs.payment"), value: "3" },
          ]}
          value={activeTab.toString()}
          onChange={(e) => setActiveTab(Number(e?.value || "0"))}
          className="w-full self-start rounded-lg bg-gray-100 p-1"
        />
      </div>
    </>
  );
};
